<script>
export default {
  computed: {
    items() {
      const steps = ['WIZARD_CREATE', 'WIZARD_ADD_AGENTS', 'WIZARD_FINISH'];

      const routes = {
        WIZARD_CREATE: 'settings_teams_new',
        WIZARD_ADD_AGENTS: 'settings_teams_add_agents',
        WIZARD_FINISH: 'settings_teams_finish',
      };

      return steps.map(step => {
        return {
          title: this.$t(`TEAMS_SETTINGS.CREATE_FLOW.${step}.TITLE`),
          body: this.$t(`TEAMS_SETTINGS.CREATE_FLOW.${step}.BODY`),
          route: routes[step],
        };
      });
    },
  },
};
</script>

<template>
  <div class="mx-auto mb-8 flex w-full min-w-0 max-w-5xl flex-col gap-6 !px-6">
    <div
      class="grid grid-cols-1 lg:grid-cols-8 lg:divide-x lg:rtl:divide-x-reverse lg:divide-n-weak rounded-xl border border-n-weak h-full min-h-[50dvh] w-full"
    >
      <woot-wizard
        class="hidden lg:block col-span-2 h-fit py-8 px-6"
        :items="items"
      />
      <router-view />
    </div>
  </div>
</template>
